/**
 * @voltxampere/spice — Resistor codec (R)
 *
 * Berkeley SPICE3 syntax: `R{name} N+ N- value`
 *
 * Examples:
 *   R1 vcc out 1k
 *   R2 in out 4.7K
 *   Rload out 0 100
 *
 * Schema mapping: `type: "resistor"`, params: `{ resistance }`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { ok, err, } from "./_base.js";
import { parseSpiceNumber, formatSpiceValue } from "../units.js";
import { numericParam } from "./_param-helpers.js";
export const resistorCodec = {
    spiceLetter: "R",
    schemaTypes: ["resistor"],
    examples: ["R1 vcc out 1k", "R2 in out 4.7K", "Rload out 0 100"],
    parse(card, _ctx) {
        if (card.tokens.length < 3) {
            return err("R needs 2 nodes and a value");
        }
        const [na, nb, raw] = card.tokens;
        if (na === undefined || nb === undefined || raw === undefined) {
            return err("R has incomplete tokens");
        }
        const value = parseSpiceNumber(raw);
        if (value === null) {
            return err(`R value '${raw}' is not a valid number`);
        }
        const component = {
            id: card.identifier,
            type: "resistor",
            position: { x: 0, y: 0 }, // from-spice will overwrite
            rotation: 0,
            flipped: false,
            label: card.identifier,
            params: { resistance: value },
            terminals: [],
        };
        return ok(component, [na, nb]);
    },
    emit(component, terminals) {
        const r = numericParam(component.params.resistance, 1000);
        const [a, b] = terminals;
        return `${component.id} ${a ?? "0"} ${b ?? "0"} ${formatSpiceValue(r)}`;
    },
    owns(schemaType) {
        return schemaType === "resistor";
    },
};
//# sourceMappingURL=resistor.js.map